import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi, EntiApi, OperatoriApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useOperatoriDataSource() {
    const api = new OperatoriApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getOperatori({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getOperatoreById({
                tenantId: currentTenant.Id,
                operatoreId: key
            });
          },
    
          insert: (values) => {
            return api.insertOperatore({
                tenantId: currentTenant.Id,
                operatoreCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateOperatore({
                tenantId: currentTenant.Id,
                operatoreId: key,
                operatoreUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteOperatore({
                tenantId: currentTenant.Id,
                operatoreId: key    
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


